module.exports = __webpack_public_path__ + "17dc8989d0eb87fa61d898de5e4c6b45.svg";